<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Grupo</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="grupo.nome"
                        placeholder="" />
                    </div>
                    <div class="col-md-4">
                      <label for="unidade_id">Unidade:</label>
                      <v-select :options="unidades" :label="'nome'" :reduce="(unidades) => unidades.id"
                        v-model="grupo.unidade_id" placeholder="Nenhuma (grupo geral)"></v-select>
                    </div>
                    <div class="col-md-4">
                      <label for="status">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="grupo.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/grupos" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  name: "grupoAdd",
  data() {
    return {
      grupo: {
        status: '1'
      },
      unidades: [],
      errors: undefined,
    };
  },
  components: {
    vSelect,
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "grupos";

      if (self.grupo.id) {
        self.grupo._method = "PUT"
        api += "/" + self.grupo.id;
      }

      axios
        .post(api, self.grupo)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/grupos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getGrupo: function (id) {
      const self = this;
      const api = self.$store.state.api + "grupos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.grupo = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data || [];
        })
        .catch(() => {});
    },
  },
  mounted: function () {
    const self = this;
    self.getUnidades();
    let id = self.$route.params.id;
    if (id) {
      self.getGrupo(id);
    }
  },
};
</script>
